import React, { useState } from 'react'
import { Box, Grid, Typography,Switch, FormControlLabel, Paper} from '@mui/material'
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Avatar from '@mui/material/Avatar';
import WorkIcon from '@mui/icons-material/Work';
import WorkOffIcon from '@mui/icons-material/WorkOff';
import CollapsibleTable from '../components/Home/CollapsibleTable';
import InsetDividers from '../components/Home/InsetDividers';
import DenseTable from '../components/Home/DenseTable';
import ResponsiveDateTimePickers from '../components/Home/ResponsiveDateTimePickers';
import JobCount from '../components/Home/JobCount';
import BasicTable from '../components/Home/BasicTable';

const actualRows = [
    {id: 1,date: '08-10-2023' , vrm: 'KL8234', status:'In Progress' ,make: 'Audi',model: 'M s5',job: '3456',description: 'MOT Job', name:'James Anderson',resource: 'MOT Bay',staff: 'Mr.Ahammed'},
    {id:2, date: '08-10-2023' , vrm: 'KL8234', status:'completed' ,make: 'Audi',model: 'M s5',job: '3456',description: 'Full Service', name:'James Anderson',resource: 'MOT Bay',staff: 'Mr.Ahammed'},
    {id:3, date: '08-10-2023' , vrm: 'KL8234', status:'invoiced' ,make: 'Audi',model: 'M s5',job: '3456',description: 'Brake Cable Change', name:'James Anderson',resource: 'MOT Bay',staff: 'Mr.Ahammed'},
    {id:4, date: '08-10-2023' , vrm: 'KL8234', status:'Expecting' ,make: 'Audi',model: 'M s5',job: '3456',description: 'Major Service', name:'James Anderson',resource: 'MOT Bay',staff: 'Mr.Ahammed'},
    {id:5, date: '08-10-2023' , vrm: 'KL8234', status:'invoiced' ,make: 'Audi',model: 'M s5',job: '3456',description: 'MOT Job', name:'James Anderson',resource: 'MOT Bay',staff: 'Mr.Ahammed'},
    // {id:3, date: '08-10-2023' , vrm: 'KL8234', status:'completed' ,make: 'Audi',model: 'M s5',job: '3456',description: 'MOT Job', name:'James Anderson',resource: 'MOT Bay',staff: 'Mr.Ahammed'},
    // {id: 1,date: '08-10-2023' , vrm: 'KL8234', status:'In Progress' ,make: 'Audi',model: 'M s5',job: '3456',description: 'MOT Job', name:'James Anderson',resource: 'MOT Bay',staff: 'Mr.Ahammed'},
  // createData('08-10-2023' , 'KL8234', 'In Progress', 'Audi', 'M s5', '3456', 'MOT Job', 'James Anderson', 'MOT Bay', 'Mr.Ahammed'),
  // createData('9.30 AM' , 'KXe344', 'completed', 'BMW', 'S5', '3125', 'Full Service', 'Alex Mathew', 'Service Bay1', 'Mr.Rasheed'),
  // createData('10-10-2023' , 'MXC3454', 'Invoiced', 'Ford', 'Figo', '3425', 'Brake Cable Change', 'Adam smith', 'General Bay2', 'Mr.Mustafa'),
  // createData('10 AM' , 'MP11XY', 'Expecting', 'Suzuki', 'Vitera', ' ', 'Major Service', 'Mr.George', ' ', ' '),

];


function Home() {
  const [isAllData, setIsAllData] = useState(false)
  const [rows, setRows]= useState(actualRows)
  const pageChange = (e) => { 
    setIsAllData(e.target.checked)
    if(e.target.checked){
      const updatedRows = rows.filter(item => item.description === 'MOT Job')
      setRows(updatedRows)
    }
    else{
      setRows(actualRows)
    }
  };

    const cardStyle = {
      height: '100px',
      boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.3)',
      borderRadius:'20px',
      
    };
    const avatarStyle = {
      width: '30px',
      height: '30px',
      bgcolor: '#c8e6c9',
    };
  return (
    <Box >
      <Grid container spacing={1}>
        <Grid item xs={1.5} display='flex' >
          <Card sx={{ height: "210px", width: "300px", borderRadius: "20px", display:'flex'}}>
            <ResponsiveDateTimePickers />
          </Card>
        </Grid>
        <Grid item xs={4}>
          <Box>
              <Grid container spacing={1} >
                <Grid item xs={6}>
                  <Card style={cardStyle} sx={{ bgcolor: "#f1f8e9"}}>
                    <CardContent>
                      <Box  display= "flex" justifyContent= "space-between">
                      <Typography>
                        Todays Schedule Job 
                      </Typography>
                      <Avatar sx={avatarStyle}>
                        <WorkIcon sx={{ color: "#66bb6a" }} />
                      </Avatar>
                      </Box>
                      <Typography variant='h5' gutterBottom>
                        15
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>

                <Grid item xs={6}>
                  <Card style={cardStyle} sx={{ bgcolor: "#f1f8e9"}}>
                    <CardContent>
                       <Box  display= "flex" justifyContent= "space-between">
                      <Typography>
                        Pending Jobs
                      </Typography>
                      <Avatar sx={avatarStyle}>
                        <WorkOffIcon sx={{ color: "#66bb6a" }} />
                      </Avatar>
                      </Box>
                      <Typography variant='h5' gutterBottom>
                        5
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={12} >
          <Box>
            <JobCount />
          </Box>
        </Grid>
              </Grid>
          </Box>
        </Grid>
        <Grid item xs={6.5} >
          <Grid container spacing={1}>
            <Grid item xs={6} display= "flex">
              <BasicTable />
            </Grid>
            <Grid item xs={6} display= "flex" >
              <DenseTable />
            </Grid>
          </Grid>
        </Grid>
        
        <Grid item xs={12}>
          <Box >
            <InsetDividers />
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box display="flex" justifyContent="flex-end" >
            <Paper sx={{ p: 1, borderRadius: "10px", bgcolor: "#f1f8e9" }}>
              <span style={{fontSize:'11px'}}>All Data</span>
              <FormControlLabel
                sx={{ marginLeft: "10px" }}
                control={
                  <Switch
                    size="small"
                    checked={isAllData}
                    color="success"
                    onChange={pageChange}
                  />
                }
              />
              <span style={{fontSize:'11px'}}>MOT</span>
            </Paper>
          </Box>
         {rows &&  <CollapsibleTable rows={rows} />}
        </Grid>
      </Grid>
    </Box>
  );
}

export default Home